// extracted by mini-css-extract-plugin
export default {"notice":"StoreNotice_notice__8TGCw","text":"StoreNotice_text__elXFN","close":"StoreNotice_close__YmrcX","link":"StoreNotice_link__DUZ1b"};